import Chase from "../../../../../../assets/svgs/BankLogo/chase.svg";
import BankOfAmerica from "../../../../../../assets/svgs/BankLogo/bankOfAmerica.svg";
import Pnc from "../../../../../../assets/svgs/BankLogo/pnc.svg";
import WellsFargo from "../../../../../../assets/svgs/BankLogo/wellsFargo.svg";
import Citi from "../../../../../../assets/svgs/BankLogo/citi.svg";
import CapitalOne from "../../../../../../assets/svgs/BankLogo/capitalOne.svg";
import UsBank from "../../../../../../assets/svgs/BankLogo/usBank.svg";
import Usaa from "../../../../../../assets/svgs/BankLogo/usaa.svg";
import TdBank from "../../../../../../assets/svgs/BankLogo/tdBank.svg";
import Suntrust from "../../../../../../assets/svgs/BankLogo/suntrust.svg";
import Regions from "../../../../../../assets/svgs/BankLogo/regions.svg";
import NavyFederal from "../../../../../../assets/svgs/BankLogo/navyFederal.svg";
import FlinksCapital from "../../../../../../assets/svgs/BankLogo/flinksCapital.svg";

export const logoes = [
  {
    img: Chase,
    name: "chase",
  },
  {
    img: FlinksCapital,
    name: "flinksCapital",
  },
  {
    img: BankOfAmerica,
    name: "bankOfAmerica",
  },
  {
    img: Pnc,
    name: "pnc",
  },
  {
    img: WellsFargo,
    name: "wellsFargo",
  },
  {
    img: Citi,
    name: "citi",
  },
  {
    img: CapitalOne,
    name: "capitalOne",
  },
  {
    img: UsBank,
    name: "usBank",
  },
  {
    img: Usaa,
    name: "usaa",
  },
  {
    img: TdBank,
    name: "tdBank",
  },
  {
    img: Suntrust,
    name: "suntrust",
  },
  {
    img: Regions,
    name: "regions",
  },
  {
    img: NavyFederal,
    name: "navyFederal",
  },
];
